import { gql } from '@apollo/client';
import { ResolverParams } from '@queries/queries.interfaces';
import { Order, DeliveryType } from '@interfaces';

export const setDeliveryTypeMutation = () => gql`
  mutation setDeliveryType($params: SetOrderDeliveryTypeParams!) {
    setOrderDeliveryType(params: $params) {
      id
      deliveryType
      orderGroupId
    }
  }
`;

export type SetDeliveryTypeMutationParams = ResolverParams<{
  orderUuid: string;
  deliveryType: DeliveryType;
}>;

export type SetDeliveryTypeMutationResponse = {
  setOrderDeliveryType: Pick<Order, 'id' | 'deliveryType' | 'orderGroupId'>;
};
